<template>
  <i class="svg-image" :class="{ inline: inline }" v-html="svgContent"></i>
</template>

<style lang="scss" scoped>
  .svg-image {
    display: flex;
    justify-content: center;
    align-items: center;

    &.inline {
      flex-grow: 1;
      flex-shrink: 1;
      width: 100%;
      height: 100%;

      svg {
        display: inline;
        max-width: 100%;
      }
    }
  }

  svg {
    flex: 1;
  }
</style>

<script>
  let SVGStore = {}

  export default {
    name: 'svg-loader',
    props: {
      src: String,
      textSlot: String,
      inline: Boolean
    },
    data: () => ({
      svgContent: null
    }),
    watch: {
      src () {
        this.svgContent = null
        this.loadSVG()
      }
    },
    methods: {
      async setSVGContent () {
        let content = await SVGStore[this.src]

        if (this.textSlot) {
          content = content.replace('{{textSlot}}', this.textSlot)
        }

        this.svgContent = content

        await this.$nextTick()

        const dataset = [].filter.call(this.$el.attributes, attribute => /^data-/.test(attribute.name))

        dataset.forEach(data => {
          const childrenArray = Array.from(this.$el.querySelectorAll('*'))

          childrenArray.forEach(node => {
            node.setAttribute(data.name.toLowerCase(), '')
          })
        })
      },
      isSVG (mimetype) {
        return mimetype.indexOf('svg') >= 0
      },
      loadSVG () {
        if (!SVGStore.hasOwnProperty(this.src)) {
          SVGStore[this.src] = new Promise((resolve, reject) => {
            const request = new window.XMLHttpRequest()
            const self = this

            request.open('GET', this.src, true)
            request.onload = function () {
              const mimetype = this.getResponseHeader('content-type')

              if (this.status >= 200 && this.status < 400 && self.isSVG(mimetype)) {
                resolve(this.response)

                self.setSVGContent()
              } else {
                reject(new Error(`The file ${self.src} is not a valid SVG.`))
              }
            }
            request.send()
          })
        } else {
          this.setSVGContent()
        }
      }
    },
    mounted () {
      this.loadSVG()
    }
  }
</script>
